'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _prefix = require('../prefix');

var _prefix2 = _interopRequireDefault(_prefix);

var _pascalize = require('../utils/pascalize');

var _pascalize2 = _interopRequireDefault(_pascalize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Support old inline-logical syntax.
// See https://github.com/postcss/autoprefixer/issues/324.
exports['default'] = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
    if (_prefix2['default'].js === 'Moz') return prop;
    var newProp = prop.replace('-inline', '');
    return _prefix2['default'].js + (0, _pascalize2['default'])(newProp) in style ? _prefix2['default'].css + newProp : false;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/css-vendor/lib/plugins/inline-logical-old.js
// module id = 14
// module chunks = 0